import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { Tag } from '@delmonicos/shared-design-system-react/src/components/tag/tag';
import { Tooltip } from '@delmonicos/shared-design-system-react/src/components/tooltip/tooltip';
import { ChannelModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/charge-point/channel.model';
import classNames from 'classnames';

import { mapStatusToGenericConnectorStatus } from '@app/feature/charge-point/helper/connector-status.helper';
import { mapTypeToGenericConnectorType } from '@app/feature/charge-point/helper/connector-type.helper';

import * as css from './channel.module.scss';

interface ChannelComponentProps {
  channel: ChannelModel;
}

export const ChannelComponent = ({
  channel,
}: ChannelComponentProps): React.JSX.Element => {
  const status = mapStatusToGenericConnectorStatus(channel.computedStatus);
  const physicalSocketFirst = channel.physicalSockets.at(0);

  if (!physicalSocketFirst) {
    return (
      <Tooltip content={channel.computedStatus}>
        <Tag className={classNames([status.color], css.tag)}>
          <Icon name="x-close" />
        </Tag>
      </Tooltip>
    );
  }

  const connectorType = mapTypeToGenericConnectorType(
    physicalSocketFirst?.standard,
  );

  return (
    <Tooltip content={channel.computedStatus}>
      <Tag className={classNames([status.color], css.tag)}>
        <Icon name={connectorType.icon} />
      </Tag>
    </Tooltip>
  );
};
